import UsersService from "../../services/UsersService";

const state = {
    data: [],
    paginator: {},
    loading: false,
}

const mutations = {
	SET_USERS(state, users) {
        state.data = users;
    },
    SET_PAGINATOR(state, paginator) {
        state.paginator = paginator;
    },
    SET_LOADING(state, active){
        state.loading = active;
    }
}

const actions = {
    fetch({commit}) {
        UsersService.all().then( ({data}) => commit('SET_USERS', data.data));
    },
    search({commit}, params){
        commit('SET_LOADING', true); 
        UsersService.search(params).then( ({data}) => { 
            commit('SET_USERS', data.data); 
            commit('SET_PAGINATOR', data.meta); 
            commit('SET_LOADING', false);
        });
    }
}

const getters = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};